// 'app/views/teacher/students/_form.html.erb'用の処理
export default () => {
  const smsOptionData = document.getElementById('sms-option-data');
  // 教習生登録画面ではないか、教習生登録画面だけどSMS非対応学校だったら終了
  if (smsOptionData === null || smsOptionData.dataset.schoolSmsEnabled === 'false') return;

  // 以下、SMS対応学校のみの処理
  const studentRadioEmail = document.getElementById('student_contact_email');
  const studentRadioPhone = document.getElementById('student_contact_phone');
  const studentFormGroupEmail = document.getElementById('student-form-group-email');
  const studentFormGroupPhone = document.getElementById('student-form-group-phone');
  const studentInputEmail = document.getElementById('student_email');
  const studentInputPhone = document.getElementById('student_phone');

  const switchFormEmailOrPhone = () => {
    if (studentRadioEmail.checked) {
      studentFormGroupEmail.style.display = '';
      studentFormGroupPhone.style.display = 'none';
      studentInputEmail.disabled = false;
      studentInputPhone.disabled = true;
    }

    if (studentRadioPhone.checked) {
      studentFormGroupEmail.style.display = 'none';
      studentFormGroupPhone.style.display = '';
      studentInputEmail.disabled = true;
      studentInputPhone.disabled = false;
    }
  };

  // ページ開いた時の初期実行
  window.addEventListener('load', () => {
    switchFormEmailOrPhone();
  });

  // ラジオボタンが押された時
  studentRadioPhone.addEventListener('change', () => {
    switchFormEmailOrPhone();
  });
  studentRadioEmail.addEventListener('change', () => {
    switchFormEmailOrPhone();
  });
};
